export const HorSpacerSm = () => <div className='pl-1' />
